import { AxiosResponse } from "axios";
import { axiosObj } from "./axios";
import { SignUpResponse } from "./interfaces/auth-interface";

export const signIn = async (data: { username: string; password: string; }): Promise<AxiosResponse<SignUpResponse>> => {
  return axiosObj.post("auth/adminLogin", data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const sendEmailToResetPassword = async (email: string): Promise<AxiosResponse<SignUpResponse>> => {
  return axiosObj.get(`user/sendEmailForForgetPassword/${email}`, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const updatePassword = async (data: { email: string; key: string, password: string; }): Promise<AxiosResponse<SignUpResponse>> => {
  return axiosObj.put(`user/checkandUpdatePassword`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};


export const signOut = async (accessToken:string, data: {}): Promise<any> => {
  const logoutresponse = axiosObj.post(
    `/auth/logout`,
    data, 
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );

  return (await logoutresponse).data;
};


export const getNewAccessToken = async (data : {refreshToken:string}): Promise<any> => {
  const accessTokenRespone  = axiosObj.post(`/auth/refresh`, data, {
    headers: {
      "Content-Type": "application/json",
    }})
    return  (await accessTokenRespone).data
};



